var ReactRedux = require("react-redux");
var bindActionCreators = require("redux").bindActionCreators;
var CurrentResponseActions = require('../../../modules/responses/actions/set-current-response');
var SubmitResponseActions = require('../../../modules/responses/actions/submit-response');
var ValidationActions = require('../../../modules/responses/actions/validate');
var NavigationActions = require('../../../modules/survey/actions/surveys-navigation');
var surveyStateHistoryActions = require('../../../modules/surveyStateHistory/actions/surveyStateHistory');
var utils = require('../../../modules/survey/utils');
var Survey = require('../components/survey.jsx');


  var mapStateToProps = function(state, ownProps){
      var surveyId = utils.getSurveyId(state.surveys, state.surveys.currentSurveyIndex);
      var sequenceId = utils.getSequenceId(state.entities.surveys, surveyId, state.surveys.currentSequenceIndex); // fieldName
    var field = utils.getCurrentField(state.entities.fields, sequenceId); // ownProps.params.name
    var priorResponse = utils.getPriorResponse(state.responses.submission, field.populateWithChoicesFrom || field.enableOnlyChoicesFrom); // default to []

    return {
      field: field,
      priorResponse: priorResponse,
      progress: state.surveys.progress,
      responses: state.responses
    };
  }

  var mapDispatchToProps = function(dispatch) {
    return bindActionCreators(Object.assign({}, CurrentResponseActions, SubmitResponseActions, ValidationActions, NavigationActions, surveyStateHistoryActions), dispatch);
  }

module.exports = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(Survey);



// WEBPACK FOOTER //
// ./src/common/routes/survey/containers/survey.jsx